// This page is for Sign pdf after submit application, It will open Iframe to
sign using Hellosign API
<template>
  <div class="flex items-center min-h-screen w-full">
    <div class="w-full bg-gray-50 rounded shadow-lg p-8 m-4 md:max-w-md md:mx-auto">
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <p class="text-md mt-1" v-if="is_signed">{{text}}</p>
          <p class="text-md mt-1" v-if="!is_signed">
            Thank you for joining our network! Your application has been submitted but we still need your signature. Please click the button below to sign your application.
            <br />
            <br />Some browsers automatically disable pop-ups. For your convenience (if the pop-up does not work for you),
            we also provice option to sign via email, you will get a copy of your application for you to access and apply the electronic signature that way.
          </p>
        </div>
      </div>

      <button
        style="margin-left:28%"
        v-if="!is_signed"
        type="button"
        id="sign_doc"
        @click="generateSignRequest()"
        class="md:col-span-6 col-span-3 md:w-auto w-full justify-self-start inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-200"
      >Sign Application</button>
      <button
        style="margin-left:22%"
        v-if="!is_signed"
        type="button"
        id="sign_doc"
        @click="createEmailSignRequest()"
        class="mt-5 md:col-span-6 col-span-3 md:w-auto w-full justify-self-start inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-200"
      >Sign Application Via Email</button>
    </div>
  </div>
</template>
<script>
import HelloSign from "hellosign-embedded";
const client = new HelloSign();
import { mapState } from "vuex";
export default {
  name: "HelloSign",
  components: {},
  computed: mapState(["attorney_data"]),
  data() {
    return {
      is_signed: false,
      text:
        "Thank you for joining our network! Your application has been submitted but we still need your signature. Please click the button below to sign your application. Some browsers automatically disable pop-ups. For your convenience (if the pop-up does not work for you), we've also emailed you a copy of your application for you to access and apply the electronic signature that way."
    };
  },
  mounted() {
    if (this.attorney_data.signed) {
      this.is_signed = true;
      this.text =
        "Your application is submitted and signed. It will be reviewed by our Provider Relations team. Upon approval, you will receive a welcome email with additional information and access to your U.S. Legal Attorney Portal. Thank you for joining our network!";
    }
    client.on("sign", data => {
      console.log("The document has been signed!");
      console.log("Signature ID: " + data.signatureId);
      this.is_signed = true;
      this.text =
        "Your application is submitted and signed. It will be reviewed by our Provider Relations team. Upon approval, you will receive a welcome email with additional information and access to your U.S. Legal Attorney Portal. Thank you for joining our network!";
      let att_data = this.attorney_data;
      att_data["signed"] = true;
      localStorage.setItem("attorney_data", JSON.stringify(att_data));
      this.$store.dispatch("setAttorneyData");
    });
  },
  methods: {
    generateSignRequest: function() {
      this.$toast.success(
        "Please wait.. your Network Attorney Application is loading so that you can electronically sign your application. Thank you.",
        { position: "top", duration: "20000" }
      );
      this.$store.dispatch("createSignRequest", this.attorney_data).then(
        response => {
          console.log(response);
          setTimeout(() => {
            if (response.data != null && response.data != "") {
              if (
                window.location.origin !=
                  "https://devattportal.uslegalservices.net" &&
                window.location.origin != "http://localhost:8080"
              ) {
                client.open(response.data, {
                  clientId: "f3c2738874829d6895be9e57f3c37103",
                  skipDomainVerification: true,
                  allowCancel: false,
                  timeout: 50000
                });
              } else {
                client.open(response.data, {
                  clientId: "83e9e6fb8fc867b64930cbb8e145facd",
                  skipDomainVerification: true,
                  allowCancel: false,
                  timeout: 50000
                });
              }
            } else {
              this.$toast.error("Something went wrong, please try again");
            }
          }, 1000);
        },
        error => {
          console.log(error);
          this.$toast.error("Something went wrong, please try again");
        }
      );
    },
    createEmailSignRequest: function() {
      this.$store.dispatch("createEmailSignRequest", this.attorney_data).then(
        response => {
          console.log(response);
          setTimeout(() => {
            if (response.data != null && response.data != "") {
              this.is_signed = true;
              this.text =
                "Your application is submitted. If you selected to sign your application by email, please check your email and submit your signature. Your signed application will be reviewed by our Provider Relations team. Upon approval, you will receive a welcome email with additional information and access to your U.S. Legal Attorney Portal. Thank you for joining our network!";
              let att_data = this.attorney_data;
              att_data["signed"] = true;
              localStorage.setItem("attorney_data", JSON.stringify(att_data));
              this.$store.dispatch("setAttorneyData");
              this.$toast.success(
                "Email sent to your email, please check and sign the doc"
              );
            } else {
              this.$toast.error("Something went wrong, please try again");
            }
          }, 1000);
        },
        error => {
          console.log(error);
          this.$toast.error("Something went wrong, please try again");
        }
      );
    }
  }
};
</script>
